<template>
    <div class="admin-table-page">
        <div v-if="!noData">
            <div class="table-tools">
                <!--<el-button type="primary" class="c-f-left">创建项目</el-button>-->
                <span class="c-f-right">
                <span class="time-label">创建时间范围</span>
                 <span class="c-search-box c-f-right">
                    <el-input v-model="tableOptions.params.name" @keyup.enter.native="onSearchChange" placeholder="输入项目搜索"></el-input>
                    <el-button @click="onSearchChange" type="primary" circle class="c-search-btn"><i class="iconfont icon-search"></i></el-button>
                </span>
                    <el-date-picker @change="onTimeChange" class="time-section"
                                    v-model="startTime"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                    </el-date-picker>
                </span>
            </div>
            <el-table :data="tableDataMixin" class="table-area" v-loading="tableLoadingMixin"
                      element-loading-text="拼命查询中, 请稍候"
                      element-loading-spinner="el-icon-loading"
                      style="width: 100%">
                <el-table-column v-for="(item, index) in columnInfo" :key="index" :label="item.label" :formatter="item.formatter"
                                 :min-width="item['min-width']" :prop="item.prop" :align="item.align">
                </el-table-column>
                <el-table-column
                        label="操作"
                        width="120">
                    <template slot-scope="scope">
                    <span v-loading="scope.row.loading">
                         <a class="c-main-color" @click="handleEdit(scope.$index, scope.row, 'APPROVED')"
                            v-if="scope.row.reviewStatus === 'PENDING'">通过</a>
                        <a class="c-main-color" @click="handleEdit(scope.$index, scope.row, 'DENIED')"
                           v-if="scope.row.reviewStatus === 'PENDING'">拒绝</a>
                    </span>
                        <span class="c-red" v-if="scope.row.reviewStatus === 'DENIED'">已拒绝</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="no-data" v-show="isSearching">
                <noResult>
                    <div style="line-height: 17px;">
                        <template v-if="searchTip">
                            <div class="title">当前项目未搜索到项目“<span class="c-red">{{searchTip}}</span>”</div>
                            <div class="c-gray">请确认并重新输入项目名称进行搜索</div>
                        </template>
                        <template v-else-if="startTime">
                            <div class="title">当前时间范围无数据，请重新选择时间</div>
                            <div class="c-red">{{ tableOptions.params.createTimeStart }} - {{tableOptions.params.createTimeEnd}}</div>
                        </template>
                    </div>
                </noResult>
            </div>
            <el-pagination class="page-area" v-if="tableDataMixin.length"
                           background
                           :total="totalDataMixin"
                           :page-size="queryMixin.pageSize"
                           :page-sizes="[10, 20, 30]"
                           layout="sizes, total, ->, prev, pager, next, jumper"
                           :current-page="queryMixin.pageNum"
                           @size-change="handleSizeChangeMixin"
                           @current-change="handleCurrentChangeMixin">
            </el-pagination>
        </div>
        <noResult v-if="noData">
            <div class="title">暂无数据</div>
        </noResult>
    </div>
</template>
<script>
    // PENDING,  //待审批
    // APPROVED, //审批通过
    // DENIED,   //审批驳回
    import mix from '@/mixins/table-mixin.js'
    import noResult from '@/views/components/noResult'
    import projectService from '../../../request/service/project-service'
    import {PROJECT_APPROVAL_TABLE} from '../../../request/api/project-api'

    export default {
        mixins: [mix],
        components: {
            noResult,
        },
        data() {
            return {
                startTime: null,
                columnInfo: [],
                noData: false,
                searchTip: '',
                tableOptions: {
                    url: PROJECT_APPROVAL_TABLE,
                    params: {
                        createTimeStart: null,
                        createTimeEnd: null,
                        name: '',
                    }
                }
            }
        },
        computed: {
            isSearching () {
                return (this.searchTip || this.startTime) && this.tableDataMixin.length === 0;
            }
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                this.getColumnInfo();
                this.getDataMixin().then(({list}) => {
                    this.noData = list.length === 0;
                });
            },
            noSearchData () {
                return this.tableDataMixin.length === 0 && (this.tableOptions.params.name || this.startTime);
            },
            formatterDate(row, column, cellValue) {
                return  moment(cellValue).format('YYYY-MM-DD');
            },
            getColumnInfo() {
                this.columnInfo = [
                    {label: '项目名称', prop: 'name', 'min-width': '100px', align: 'center'},
                    {label: '创建时间', prop: 'createTime', 'min-width': '60px', align: 'left', formatter: this.formatterDate},
                    {label: '申请人', prop: 'applicant', 'min-width': '61px', align: 'left'},
                    {label: '申请人邮箱', prop: 'applicantEmail', 'min-width': '135px', align: 'left'},
                    {label: '管理管理员', prop: 'adminEmail', 'min-width': '135px', align: 'left'}
                ]
            },
            handleEdit(index, row, reviewStatus) {
                this.$set(row, 'loading', true);
                projectService.review(row.id, reviewStatus).then(() => {
                    this.$message.success('操作成功');
                    this.getDataMixin();
                }).finally(() =>{
                    row.loading = false;
                });
            },
            onTimeChange(timeArray) {
                let start = null;
                let end = null;
                if (timeArray) {
                    start = moment(timeArray[0]).format('YYYY-MM-DD HH:mm:ss');
                    end = moment(timeArray[1]).format('YYYY-MM-DD HH:mm:ss');
                }
                this.tableOptions.params.createTimeStart = start;
                this.tableOptions.params.createTimeEnd = end;
                this.getDataMixin();
            },
            onSearchChange() {
                this.getDataMixin().finally(() => {
                    this.searchTip = this.tableOptions.params.name;
                });
            },
        }
    }
</script>

